module.exports = __webpack_public_path__ + "app-static/img/08.429f450d.jpg";